import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import appAPI from '../../api/app';
import { Types, Creators as AppCreators } from '../../reducers/app';
import getState from '../../utils/getState';

function* seoRequest({ page }) {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(appAPI.seoRequest, page, siteId);

    yield put(AppCreators.seoSuccess(data));
  } catch (error) {
    yield put(AppCreators.seoError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEO_REQUEST, seoRequest);
}
